import React from 'react'
import Flex from 'typescript-styled-flex'
import { useTranslation } from 'react-i18next'
import { FiStar } from 'react-icons/fi'
import { Color } from '../ColorPalette'
import { theme } from '../../theme'
import State from './LimitItem/State'

function LimitGird({ children, padding = '38px' }) {
  const { t } = useTranslation()

  return (
    <>
      <Flex full={true} style={{ marginTop: padding, maxHeight: '51px' }}>
        <Flex style={{ width: '60%' }} />
        <Flex
          alignEnd={true}
          justifyCenter={true}
          style={{ minWidth: '90px', paddingBottom: '10px', width: '20%' }}
        >
          <State>{t('free')}</State>
        </Flex>
        <Flex
          column={true}
          alignCenter={true}
          justifyCenter={true}
          style={{
            background: theme.colors.palette.paleGrey,
            minWidth: '90px',
            paddingBottom: '10px',
            width: '20%',
          }}
        >
          <Color
            width={'32px'}
            height={'32px'}
            style={{
              marginTop: '-16px',
              maxHeight: '32px',
              maxWidth: '32px',
              minHeight: '32px',
              minWidth: '32px',
            }}
            color={theme.colors.palette.emerald}
          >
            <FiStar size={18} />
          </Color>
          <State style={{ color: '#02a642' }}>{t('menu_upgrade')}</State>
        </Flex>
      </Flex>
      {children}
    </>
  )
}

export default LimitGird
